import React from 'react';
import block from 'bem-cn';
import './TableHead.scss';

const TableHead = ({ locale }) => {
  const b = block('table-head-cashback-history-desktop');

  return (
    <div className={b()}>
      <div className={b('table-head')}>{locale.date}</div>
      <div className={b('table-head')}>{locale.id}</div>
      <div className={b('table-head')}>{locale.username}</div>
      <div className={b('table-head')}>{locale.amount}</div>
      <div className={b('table-head')}>{locale.cashback} %</div>
    </div>
  );
};

export default TableHead;
